module.exports = __webpack_public_path__ + "img/mercantile-small@3x.c24a44b6.jpg";